define(function (require) {

    "use strict";

    var $ = require("jquery");
    var introJs = require("intro-js");
    var _ = require("underscore");
    var cookie = require("cookie");
    var querystring = require("querystring");

    var tourStarted = false;

    if (!(window.scan && window.scan.guidedTours && Array.isArray(window.scan.guidedTours))) {
        return;
    }

    // iterate through all of the guided tours we have any initialize them.
    for (var i in window.scan.guidedTours) {

        if (!window.scan.guidedTours.hasOwnProperty(i)) {
            continue;
        }

        (function (tour) {

            // if we're supposed to show the tour on page load, start the tour immediately.
            if (tour.showOnPageLoad) {
                // don't display the tour if the link indicates that autoplay should be suppressed
                if (querystring.parse()["suppressTour"] === "1") {
                    // and set it as displayed if the tour is configured to display only once
                    if (tour.displayOnlyOnce) {
                        setTourDisplayed(tour);
                    }

                    return;
                }

                displayTour(tour);
            }

            // if we're supposed to show the tour when the user clicks on something, bind the click event handler.
            if (tour.triggerSelector) {
                $(document).on('click',
                    tour.triggerSelector,
                    function (e) {
                        e.preventDefault();

                        displayTour(tour);
                    });
            }

        })(window.scan.guidedTours[i]);
    }

    // displays the given guided tour
    function displayTour(tour) {
        if (tourStarted) {
            return;
        }

        if (tour.displayOnlyOnce && cookie.get('tour.' + tour.id)) {
            return;
        }

        tourStarted = true;

        // create a clone of the options since we're going to be modifying them.
        var options = _.extend({}, tour);

        // filter out steps whose element selector is set,
        // but the element isn't present on the page.
        options.steps = _.filter(options.steps,
            function (step) {
                // always show those without any selector
                // always show those that aren't set to hide if missing
                return !step.element || !step.hideIfMissing || document.querySelector(step.element);
            });

        introJs.introJs()
            .setOptions(options)
            .onchange(function () {
                // unfortunately, the introJS api does not provide a reference to which
                // step that is being displayed.  it does provides the DOM node
                // (via the only function argument) but this is not sufficent to identity the step.
                // therefore, we have to use the this._currentStep internal property.
                // it is zero based.
                var step = options.steps[this._currentStep];
                if (step && step.enableGoogleAnalyticsEvent && window.dataLayer) {
                    window.dataLayer.push({
                        'event': 'virtualPageview',
                        'virtualPageURL': step.virtualPageUrl,
                        'virtualPageTitle': step.virtualPageTitle
                    });
                }
            })
            .onexit(function () {
                tourStarted = false;
            })
            .start();

        // if we're hiding this tour after the initial view, track that the user saw this tour via a cookie.
        if (tour.displayOnlyOnce) {
            setTourDisplayed(tour);
        }
    }

    function setTourDisplayed(tour) {
        cookie.set('tour.' + tour.id, true, { expires: 3650 }); // 10 yr expiration
    }
});
